import React from 'react';
import { useTheme } from '@mui/material';
import { useThemeSettings } from '@webbyx/mui';
import { ApexOptions } from 'apexcharts';

import { ChartProps } from '../props';
import ReactApexcharts from '../react-apexchart';

export const DonutChart: React.FC<ChartProps> = (props) => {
  const { colors, data } = props;
  const theme = useTheme();
  const { settings } = useThemeSettings();

  const options: ApexOptions = {
    stroke: { width: 0 },
    labels: data?.labels ?? [],
    colors: colors,
    chart: {
      background: 'transparent !important',
    },
    dataLabels: {
      enabled: false,
    },
    legend: {
      show: false,
    },
    theme: {
      mode: settings.mode === 'semi-dark' ? 'light' : settings.mode,
    },
    plotOptions: {
      pie: {
        donut: {
          labels: {
            show: true,
            value: {
              fontSize: '1.2rem',
              fontWeight: 500,
              fontFamily:
                "Inter,sans-serif,-apple-system,BlinkMacSystemFont,'Segoe UI',Roboto,'Helvetica Neue',Arial,sans-serif,'Apple Color Emoji','Segoe UI Emoji','Segoe UI Symbol'",
              color: theme.palette.text.primary,
              formatter: (val: string) => `${parseInt(val, 10)}`,
            },
            total: {
              show: true,
              showAlways: true,
              fontSize: '1rem',
              label: 'Total',
              fontFamily:
                "Inter,sans-serif,-apple-system,BlinkMacSystemFont,'Segoe UI',Roboto,'Helvetica Neue',Arial,sans-serif,'Apple Color Emoji','Segoe UI Emoji','Segoe UI Symbol'",
              fontWeight: 500,
              formatter: () => data?.total?.toString() ?? '0',
              color: theme.palette.text.secondary,
            },
          },
        },
      },
    },
    responsive: [
      {
        options: {
          plotOptions: {
            pie: {
              donut: {
                labels: {
                  show: true,
                  value: {
                    fontSize: '1rem',
                  },
                  total: {
                    fontSize: '1rem',
                  },
                },
              },
            },
          },
        },
      },
    ],
  };

  return (
    <ReactApexcharts
      type="donut"
      height={'auto'}
      options={options}
      series={data?.series ?? []}
    />
  );
};

export default DonutChart;
